/* global Phaser, game */

var menuState = {

	audio_menu: null,

	create: function() {

		game.sound.stopAll();

		this.game.add.sprite( 0, 0, 'intro' );

		// Start the game when the screen is tapped
		this.input.onDown.addOnce( this.start, this );

		game.camera.flash( 0xffffff, 1000 );

		this.audio_menu = game.add.audio( 'menu' );
		this.audio_menu.fadeIn( 1500, true );

	},

	start: function() {

		window.focus();

		game.state.start( 'play' );

		this.audio_menu.fadeOut();

	}

};
